import React, { useState } from 'react'
import { House, Mail, PhoneCall } from 'lucide-react'
import CommonForm from '../../components/common-form'
import { enquiryFormControls, initialEnquiryFormData } from '../../config'
import { createEnquiry } from '../../services'
import { toast } from 'sonner'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
export default function ContactUs({ fullScreen = true }) {
  const [enquiryFormData, setEnquiryFormData] = useState(initialEnquiryFormData)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/')
  }

  const handleEnquireFormSubmit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)

    try {
      const payload = {
        name: enquiryFormData.name,
        email: enquiryFormData.email,
        mobile: enquiryFormData.phone,
        message: enquiryFormData.message,
      }
      const response = await createEnquiry(payload)

      if (response?.status === 200) {
        toast.success('Enquiry submitted successfully!')
        setEnquiryFormData(initialEnquiryFormData)
        setTimeout(() => {
          if (localStorage.getItem('accessToken')) {
            navigate('/business/dashboard')
          } else navigate('/')
        }, 1500)
      } else {
        toast.error(response?.message || 'Failed to submit enquiry')
      }
    } catch (error) {
      toast.error(error?.response?.message || 'Something went wrong!')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-10">
      <div className="w-full px-2 flex justify-center">
        <div className="bg-light-purple rounded-2xl flex flex-col gap-6 shadow-2xl px-4 md:px-6 py-4 md:py-10 w-full max-w-md sm:max-w-lg">
          <h1 className="text-2xl md:text-4xl font-semibold text-heading-primary text-center">
            {' '}
            <ArrowLeft className="cursor-pointer hover:opacity-70" size={24} onClick={handleBack} />
            Enquiry
          </h1>

          <p className="mb-2 text-center text-gray-600">
            Have a question or need more details? Fill out the enquiry form below and our team will
            get back to you shortly.
          </p>

          <CommonForm
            formControls={enquiryFormControls}
            buttonText="Submit"
            formData={enquiryFormData}
            setFormData={setEnquiryFormData}
            isButtonDisabled={isSubmitting}
            handleSubmit={handleEnquireFormSubmit}
            buttonClass="bg-heading-primary text-white rounded-full text-base px-5 py-3 w-full cursor-pointer hover:bg-heading-primary-400 transition duration-200 ease-in-out"
          />
        </div>
      </div>
    </div>
  )
}
